import script from "./DashboardSchoolStundents.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardSchoolStundents.vue?vue&type=script&setup=true&lang=js"

import "./DashboardSchoolStundents.vue?vue&type=style&index=0&id=1fffa5bf&lang=scss"

const __exports__ = script;

export default __exports__